import { useEffect, useRef, useState } from 'react';

import Simulator from '../../threejs/simulator';

interface Props {
  scale?: number;
  autoRotate?: boolean;
}

const AircraftInline: React.FC<Props> = ({
  scale = 0.6,
  autoRotate = true,
}) => {
  let canvasRef = useRef(null);
  const [simulation, setSimulation] = useState<Simulator>();

  useEffect(() => {
    return () => {
      if (simulation) {
        simulation.dispose();
      }
    };
  }, [simulation]);

  useEffect(() => {
    if (canvasRef.current)
      setSimulation(
        new Simulator(canvasRef.current, {
          resource: 'plane-transformed.glb',
          autoRotate,
          scale,
          flying: true,
          initialRotation: { x: 0.6, y: -1.6, z: 0 },
        })
      );
  }, [autoRotate, canvasRef, scale]);

  return <canvas ref={canvasRef} width={400} height={400} />;
};

export default AircraftInline;
